export default {
  data() {
    return {
      address: '',
      threshold: 300
    };
  },
  created() {},
  mounted() {
    window.addEventListener('scroll', this.scrollHandler);
  },
  methods: {
    scrollHandler() {
      if (window.scrollY > this.threshold) {
        this.afterScroll(true);
      } else {
        this.afterScroll(false);
      }
    },
    afterScroll() {}
  },
  beforeDestroy() {
    // 确保在组件销毁前移除事件监听器
    window.removeEventListener('scroll', this.scrollHandler);
  }
};
